import { useTranslation } from 'react-i18next';
import { Row, Col } from 'antd';
import { config } from '../../config';
import styles from './Footer.module.scss';
import IcecreamLogo from 'components/IcecreamLogo/IcecreamLogo';
import { ResponsiveContainer, Typography } from '@sunday/component';
import cn from 'classnames';
import menu from './menu.json';
import insurer from './insurer.json';

const { ASSET_PREFIX } = config;
const Footer = () => {
  const { t } = useTranslation(['footer']);
  
  return (
  <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
  <ResponsiveContainer className={styles.center}>
    <Row className={styles.container}>
      <Col xl={24} xs={0}>
        <Row>
          <Col xl={6} className={styles.column}>
            <IcecreamLogo />
            <Typography.Body designLevel={2} weight={'bold'} style={{ marginTop: "32px" }}>
              {t('companyName')}
            </Typography.Body>
            <Typography.Body designLevel={2} style={{ marginBottom: "32px" }}>
              {t('address')}
            </Typography.Body>
            <div className={styles.contact}>
              <img
                width={24}
                height={24}
                src={`${ASSET_PREFIX}/static/icon/ic-phone.svg`} alt={'phone'} />
              <a href={`tel:${t('phone')}`}>
                <Typography.Body designLevel={2}>
                  {t('phone')}
                </Typography.Body>
              </a>
            </div>
            <div className={styles.contact}>
              <img
                width={24}
                height={24}
                src={`${ASSET_PREFIX}/static/icon/ic-mail.svg`} alt={'email'} />
              <a href={`mailto:${t('email')}`}>
                <Typography.Body designLevel={2}>
                  {t('email')}
                </Typography.Body>
              </a>
            </div>
          </Col>
          <Col xl={6} className={styles.column}>
            <Typography.Title designLevel={3} weight={'bold'} className={styles.title}>
              <a href="/#products">{t('products.title')}</a>
            </Typography.Title>
          </Col>
          <Col xl={6} className={styles.column}>
            <Typography.Title designLevel={3} weight={'bold'} className={styles.title}>
              {t('others.title')}
            </Typography.Title>
            {menu.others.map((item: any, index: number) => (
              <Typography.Body designLevel={2} key={`others-${index}+1`} className={styles.menu}>
                <a href={item.link}>
                  {t(item.title)}
                </a>
              </Typography.Body>
            ))}
          </Col>
        </Row>
        <Row style={{ marginTop: "8px" }}>
          <Col xl={6} className={styles.column}>
            <Typography.Title designLevel={3} weight={'bold'} className={styles.title}>
              {t('license.title')}
            </Typography.Title>
            <img
              width={65}
              height={24}
              src={`${ASSET_PREFIX}/static/img/img-ojk-license.png`}
              alt="ojk"
            />
            <Typography.Body designLevel={2} className={styles.title}>
              {t('license.detail')}
            </Typography.Body>
          </Col>
          <Col xl={14} className={styles.column}>
            <Typography.Title designLevel={3} weight={'bold'} className={styles.title}>
              {t('insurancePartners')}
            </Typography.Title>
            <div>
              {
                insurer.map((item: any, index: number) => (
                  <img
                    key={`insurer-${index+1}`}
                    src={`${ASSET_PREFIX}/static/img/footer/${item}`}
                    alt={item}
                    style={{ margin: "0 16px 24px 0" }}
                  /> 
                ))
              }
            </div>
          </Col>
        </Row>
      </Col>
      {/* mobile */}
      <Col xl={0} xs={24} className={cn(styles.column, styles.mobileFooter)}>
        <div className={styles.row} >
          <IcecreamLogo />
          <div className={styles.row}>
            <a href={`tel:${t('phone')}`}>
              <img
                width={24}
                height={24}
                src={`${ASSET_PREFIX}/static/icon/ic-phone.svg`}
                alt={'phone'}
              />
            </a>
            <a href={`mailto:${t('email')}`}>
              <img
                width={24}
                height={24}
                src={`${ASSET_PREFIX}/static/icon/ic-mail.svg`}
                alt={'mail'}
              />
            </a>
          </div>
        </div>
        <div className={styles.column}>
          <Typography.Label designLevel={1} weight={'bold'} style={{ marginTop: "32px" }}>
            {t('companyName')}
          </Typography.Label>
          <Typography.Label designLevel={1} style={{ marginBottom: "16px" }}>
            {t('address')}
          </Typography.Label>
        </div>

        <Typography.Body designLevel={3} weight={'bold'} className={styles.title}>
          <a href="/#products">{t('products.title')}</a>
        </Typography.Body>
        <Typography.Body designLevel={3} weight={'bold'} className={styles.title}>
          {t('others.title')}
        </Typography.Body>
        {menu.others.map((item: any, index: number) => (
          <Typography.Label designLevel={1} key={`others-${index}+1`} className={styles.menu}>
            <a href={item.link}>
              {t(item.title)}
            </a>
          </Typography.Label>
        ))}

        <Typography.Body designLevel={3} weight={'bold'} className={styles.title}>
          {t('license.title')}
        </Typography.Body>
        <img
          width={65}
          height={24}
          src={`${ASSET_PREFIX}/static/img/img-ojk-license.png`}
          alt="ojk"
          style={{ marginTop: "0" }}
        />
        <Typography.Label designLevel={1} className={styles.title}>
          {t('license.detail')}
        </Typography.Label>
    
        <Typography.Body designLevel={3} weight={'bold'} className={styles.title}>
          {t('insurancePartners')}
        </Typography.Body>
        <div>
          {
            insurer.map((item: any, index: number) => (
              <img
                key={`insurer-${index+1}`}
                src={`${ASSET_PREFIX}/static/img/footer/${item}`}
                alt={item}
                style={{ margin: "0 16px 24px 0" }}
              /> 
            ))
          }
        </div>
      </Col>
    </Row>
  </ResponsiveContainer>
  <Row className={styles.license}>
    <ResponsiveContainer className={styles.center}>
      <Typography.Label designLevel={1}>
        {t('copyright')}
      </Typography.Label>
    </ResponsiveContainer>
  </Row>
</div>
);

};

export default Footer;
